import { colors } from 'theme'
import css from 'styled-jsx/css'

export default css`
  .parent-searcher {
    padding: 1rem 0;
  }

  .search-container {
    margin-bottom: 1rem;
  }

  .search-results {
    position: relative;
    z-index: 10;
  }

  .loading {
    padding: 1rem;
    text-align: center;
    color: ${colors.textSecondary || '#666'};
    border: 1px solid ${colors.border || '#e0e0e0'};
    border-radius: 4px;
    background-color: ${colors.background || '#fff'};
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 0.5rem;
  }

  .loading span {
    font-style: italic;
    font-size: 0.9rem;
  }

  .results-list h6 {
    margin: 0 0 1rem 0;
    color: ${colors.text};
    font-size: 0.9rem;
    font-weight: bold;
  }

  .search-result-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0.75rem;
    margin-bottom: 0.5rem;
    border: 1px solid ${colors.border || '#e0e0e0'};
    border-radius: 4px;
    background-color: ${colors.background || '#fff'};
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  }

  .search-result-item:hover {
    border-color: ${colors.primary || '#007bff'};
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.15);
  }

  .parent-info {
    flex: 1;
  }

  .parent-name {
    font-weight: bold;
    color: ${colors.text};
    margin-bottom: 0.25rem;
  }

  .parent-email {
    font-size: 0.85rem;
    color: ${colors.alpha ? colors.alpha(colors.black, 0.6) : '#666'};
    margin-bottom: 0.1rem;
  }

  .parent-phone {
    font-size: 0.85rem;
    color: ${colors.alpha ? colors.alpha(colors.black, 0.6) : '#666'};
  }

  .parent-actions {
    margin-left: 1rem;
  }

  .no-results {
    padding: 1rem;
    text-align: center;
    color: ${colors.textSecondary || '#666'};
    font-style: italic;
    border: 1px dashed ${colors.border || '#e0e0e0'};
    border-radius: 4px;
    background-color: ${colors.backgroundLight || '#f8f9fa'};
  }
`
